import { useMemo } from 'react';

function hashStr(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

interface IdenticonProps {
  name: string;
  size?: number;
}

export const Identicon = ({ name, size = 18 }: IdenticonProps) => {
  const { grid, hue } = useMemo(() => {
    const h = hashStr(name);
    const cells: boolean[] = [];
    for (let i = 0; i < 15; i++) cells.push(((h >> i) & 1) === 1);
    const g: boolean[] = [];
    for (let r = 0; r < 5; r++) {
      for (let c = 0; c < 5; c++) {
        const cc = c < 3 ? c : 4 - c;
        g.push(cells[r * 3 + cc]);
      }
    }
    return { grid: g, hue: h % 360 };
  }, [name]);

  return (
    <div
      className='grid shrink-0 grid-cols-5 grid-rows-5'
      style={{
        width: size,
        height: size,
        gap: 1,
      }}
      aria-hidden='true'
    >
      {grid.map((on, i) => (
        <span
          key={i}
          className='rounded-[1px]'
          style={{
            background: on ? `oklch(0.55 0.15 ${hue})` : 'transparent',
          }}
        />
      ))}
    </div>
  );
};

export function hueForId(id: string): number {
  return hashStr(id) % 360;
}
